export default __webpack_public_path__ + "static/media/vid4.881b08ec.mp4";